export default __webpack_public_path__ + "static/media/transition.2f22f580.svg";